<template>
  <v-content>
    <v-layout>
      <v-flex xs12>
        <v-layout justify-space-between px-12 pa-4
                  :style="{'background-image': `url('`+ require('../assets/bg-login.jpg') +`')`}"
                  style="background-size: cover">
          <v-layout>
            <v-flex shrink mr-3 style="text-align: center;">
              <img alt="Vue logo" src="../assets/logo.png" style="width: 60px;cursor: pointer;" @click="$router.push('/manage-user-accounts').catch(err => {})">
            </v-flex>
            <v-flex shrink class="mt-1" style="text-align: left;cursor: pointer;" @click="$router.push('/manage-user-accounts').catch(err => {})">
              ฐานข้อมูลกลาง<br>
              <b>คุณลักษณะเฉพาะสิ่งอุปกรณ์สายแพทย์</b>
            </v-flex>
          </v-layout>

          <v-flex shrink class="mt-4" style="text-align: right;color: #527281;">
            <v-icon class="mr-1" style="font-size: 40px; color: #527281;">account_circle</v-icon>
            <b>{{ name_login }}</b>
            <v-menu offset-y bottom left id="menuFormHome">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon style="color: #527281">brightness_5</v-icon>
                </v-btn>
              </template>
              <v-list id="menulistHome">
                <v-layout py-2 px-4 style="background-color: #E5E5E5; text-align: left">
                  <v-flex>
<!--                    <v-list-tile>-->
<!--                      <v-list-tile-title>-->
                        <span>ข้อมูลส่วนตัว</span>
<!--                      </v-list-tile-title>-->
<!--                    </v-list-tile>-->
                  </v-flex>
                </v-layout>

                <v-list-item-title
                  class="menu-list-home"
                  @click="$router.push('/edit-user').catch(err => {})"
                >
                  <div style="border-bottom: 1px solid #E5E5E5; text-align: left;cursor: pointer;">
                    <v-flex class="my-1 mx-4">
                      <v-icon class="mr-4">edit</v-icon>
                      <span style="font-size: 12px;">แก้ไขโปรไฟล์</span>
                    </v-flex>
                  </div>
                </v-list-item-title>

                <v-list-item-title
                  class="menu-list-home"
                  @click="$router.push('/edit-password').catch(err => {})"
                >
                  <div style="border-bottom: 1px solid #E5E5E5; text-align: left;cursor: pointer;">
                    <v-flex class="my-1 mx-4">
                      <v-icon class="mr-4">lock</v-icon>
                      <span style="font-size: 12px;">แก้ไขรหัสผ่าน</span>
                    </v-flex>
                  </div>
                </v-list-item-title>

                <v-list-item-title
                  class="menu-list-home"
                  @click="logout()"
                >
                  <div style="border-bottom: 1px solid #E5E5E5; text-align: left;cursor: pointer;">
                    <v-flex class="my-1 mx-4">
                      <v-icon class="mr-4">exit_to_app</v-icon>
                      <span style="font-size: 12px;">ออกจากระบบ</span>
                    </v-flex>
                  </div>
                </v-list-item-title>

              </v-list>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
    import Service from '../service'
    import Cookies from 'js-cookie';

    export default {
        name: "Header",

        created() {
          this.getUser();
          this.check_login();
        },

        data: () => ({
            name_login: '',
        }),

        methods: {
            getUser() {
                Service.Auth.getUser().then(data => {
                    this.name_login = data.firstname +' '+ data.lastname;
                })
            },
            check_login() {
                Service.Auth.getUser()
                    .then(data => {

                    })
                    .catch(err => {
                        alert('กรุณาลงชื่อเข้าสู่ระบบ')
                        this.$router.push('/login').catch(err => {})
                    })
            },
            logout() {
                Cookies.remove('TOKEN_LOGIN');
                this.$router.push('/login').catch(err => {})
            },
        },
    }
</script>

<style lang="scss">
  .theme--light.v-list#menulistHome {
    padding-top: 0;
    padding-bottom: 0;
  }

  .v-menu__content.theme--light.menuable__content__active#menuFormHome {
    left: unset !important;
  }

  .v-list-item#listItemHome {
    padding: 0px !important;
  }

  .menu-list-home:hover {
    background: rgba(224, 216, 209, 0.15);
  }
</style>
